import React from 'react';

function StickyNav() {

  return <header id="nav" className="sticky-nav episode-page-sticky">
    <nav className="nav-container w-container">
      <div className="sub-nav-button-wrap" style={{ alignItems: 'center' }}>
        <p style={{ color: 'white', marginRight: 12, marginBottom: 0 }}>
        暢聽上萬集 Podcast！
        </p>
        <a
          href="https://www.hoost.tw/?utm_source=af&utm_medium=onelink&utm_campaign=download&pid=hoost&c=top_bar&utm_source=hoost&utm_medium=top_bar&utm_campaign=download"
          className="button button-secondary small w-button">
          免費下載APP
        </a>
      </div>
      <div className="sub-menu-wrap"/>
    </nav>
  </header>;
}

export default StickyNav;
